import { css, Interpolation, Theme } from '@emotion/react'

export const wrapper: Interpolation<Theme> = (theme) => css`
  display: flex;
  flex-direction: row;
  align-items: center;
  padding: 10px;
  gap: 12px;
  background: ${theme.backgrounds.backgroundFour};
  border: 1px solid ${theme.backgrounds.backgroundOne};
  box-shadow: ${theme.boxShadows.small};
  border-radius: 16px;
  margin: 24px 0;
  font-weight: 400;
  font-size: 12px;
  line-height: 15px;
  color: ${theme.typographyColors.typographyThree};

  .logout {
    cursor: pointer;
  }
`

export const content: Interpolation<Theme> = css`
  flex: 1;
  display: flex;
  flex-direction: column;
  gap: 5px;
`

export const name: Interpolation<Theme> = (theme) => css`
  font-weight: 700;
  font-size: 14px;
  line-height: 18px;
  color: ${theme.typographyColors.typographyTwo};
`
